import { OrderFulfillmentStatus } from '../orders.interfaces'
import { IShopifyMailingAddressInput } from './address.interfaces'

export interface IShopifyCheckoutInput {
  lineItems: IShopifyLineItem[]
  shippingAddress: IShopifyMailingAddressInput
}

export interface IShopifyCartUpdates {
  [key: number]: number
}

export interface IShopifyLineItem {
  id: number
  quantity: number
  properties?: { [key: string]: string }
}

export interface IShopifyCheckout {
  id: string
  webUrl: string
}

export interface IShopifyCheckoutResponse {
  data: {
    checkoutCreate: {
      checkout: IShopifyCheckout
    }
  }
}

export interface IShopifyRemoveTagsResponse {
  data: {
    tagsRemove: {
      node: {
        id: string
      }
    }
  }
}

export interface IShopifyAddTagsResponse {
  data: {
    tagsAdd: {
      node: {
        id: string
      }
    }
  }
}

export interface IShopifyGetFavouriteOrderResponse {
  data: {
    customer: {
      id: string
      tags: string[]
    }
  }
}

export interface IShopifyOrderMetafieldsResponse {
  data: {
    order: {
      name: string
      metafields: {
        edges: IShopifyOrderMetafieldNodeResponse[]
      }
    }
  }
}

type IShopifyOrderMetafieldNodeResponse = {
  node: IShopifyOrderMetafield
}

export interface IShopifyCheckoutNode {
  completedAt: string | null
}

export interface IShopifyNode<T> {
  data: {
    node: T
  }
}

export interface IShopifyNodes<T> {
  data: {
    nodes: T
  }
}

export interface INoteAttribute {
  name: string
  value: string
}

export interface IOrder {
  id: string
  name: string
  token: string
  customer: {
    id: string
  }
  customer_url: string
  created_at: string
  fulfillment_status: OrderFulfillmentStatus
  note_attributes: INoteAttribute[]
  total_price: string
  line_items: IShopifyLineItemRestfulResponse[]
}

export interface IShopifyLineItemRestfulResponse {
  variant_id: string
  product_id: string
  quantity: string
}

export interface IShopifyNodesRestfulApi {
  order: IOrder
}

export interface IShopifyTagsInput {
  id: string
  tags: string[]
}

export interface IFavouriteTagInput {
  orderId?: string
  customerId: string
}

export enum ShopifyMetafieldType {
  BOOLEAN = 'boolean',
  COLOR = 'color',
  DATE = 'date',
  DATE_TIME = 'date_time',
  DIMENSION = 'dimension'
}

export interface IShopifyOrderMetafield {
  id?: string
  description?: string
  namespace?: string
  key?: string
  // https://shopify.dev/apps/metafields/types
  type?: ShopifyMetafieldType
  value: string
}
